<template>
  <div>
    <!-- Trigger button -->
    <button
      class="btn btn-outline-dark border-2 w-100 btn-sm"
      data-tour="show-lab-area-btn"
      @click="toggle"
    >
      Show Lab Area
    </button>

    <!-- Bottom offcanvas panel -->
    <div
      ref="offcanvasEl"
      class="offcanvas offcanvas-bottom"
      tabindex="-1"
      :id="id"
      :aria-labelledby="`${id}-label`"
    >
      <div class="offcanvas-header border-bottom">
        <h2 :id="`${id}-label`" class="h5 mb-0 fw-semibold">Lab Area</h2>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div class="offcanvas-body" data-tour="lab-offcanvas-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { Offcanvas } from "bootstrap";

export default {
  name: "LabAreaOffcanvas",
  props: {
    id: {
      type: String,
      default: "labAreaOffcanvas"
    }
  },
  data() {
    return {
      offCanvas: null
    };
  },
  methods: {
    toggle() {
      this.offCanvas?.toggle();
    },
    show() {
      this.offCanvas?.show();
    },
    hide() {
      this.offCanvas?.hide();
    }
  },
  mounted() {
    this.offCanvas = new Offcanvas(this.$refs.offcanvasEl);
  },
  beforeUnmount() {
    this.offCanvas?.dispose();
  }
};
</script>

<style scoped>
.offcanvas {
  height: 90vh !important;
}
</style>
